import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from "./user/user.reducer";
import sideMenuReducer from "./side-menu/side-menu.reducer";
import schemaTableDataReducer from "./schema-tabledata/schema-tabledata.reducer";
import jsonToolsReducer from "./json-tools/json-tools.reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "sideMenu", "schemaTableData"],
};

const rootReducer = combineReducers({
  user: userReducer,
  sideMenu: sideMenuReducer,
  schemaTableData: schemaTableDataReducer,
  jsonTool: jsonToolsReducer
});

export default persistReducer(persistConfig, rootReducer);
